<template>
  <v-btn
    :disabled="inactive"
    :x-large="buttonSize === 'x-large'"
    :large="buttonSize === 'large'"
    :small="buttonSize === 'small'"
    :x-small="buttonSize === 'x-small'"
    outlined
    @click="addressSearch"
  >
    {{ label }}
  </v-btn>
</template>

<script>
  import * as httpConst from '../constants/httpConst'

  /**
   * 郵便番号検索
   * <zip-code-search :zip-code="xxxxxxx" @zipAddress="setZipAddress" />
   * methods:
   * setZipAddress (content) {
   *   this.prefectureCode = `${content.pref_code}`
   *   this.address = `${content.locality}${content.street}`
   * }
   */
  export default {
    name: "ZipCodeSearch",
    props: {
      zipCode: {
        type: String,
        default: ''
      },
      inactive: {
        type: Boolean,
        default: () => false,
      },
      label: {
        type: String,
        default: () => "郵便番号→住所",
      },
      buttonSize: {
        type: String,
        default: () => "small",
      }
    },
    data() {
      return {
      }
    },
    computed: {},
    methods: {
      addressSearch () {
        if (!this.zipCode) return
        const apiPath = `${httpConst.DRIVER_BASE}/api/addresses/${this.zipCode}`
        this.$http.get(apiPath).then(response => {
          this.$emit("zipAddress", response.content)
        }).catch(error => {
          console.error('郵便番号検索エラー:', error)
        })
      }
    }
  }
</script>
